/**
 * Signals tab: how many signals this source produced. The per-signal list has no API yet, so the tab states the
 * count and what a signal is rather than showing an empty table.
 */
import React from 'react';
import { Callout, EmptyState } from '../../../components/ui';
import { Info, Activity } from 'lucide-react';

interface WorkflowsTabProps {
  totalSignals: number;
}

export const WorkflowsTab: React.FC<WorkflowsTabProps> = ({ totalSignals }) => {
  if (totalSignals <= 0) {
    return (
      <EmptyState
        icon={Activity}
        title="No signals yet"
        description="Signals are extracted from harvested content. Once this source has content and the extraction pipeline has run, they appear here."
      />
    );
  }

  return (
    <Callout
      tone="accent"
      icon={Info}
      title={`${totalSignals} ${totalSignals === 1 ? 'signal' : 'signals'} from this source`}
    >
      Signal extraction links harvested posts to assets and outcomes. These signals feed strategy candidates. The
      signal-by-signal list is not available yet.
    </Callout>
  );
};
